<template>
    <div class='Blog'>
        <div class="card">
              <div class="card-header">

                <div class="row">
                    <div class="col-sm-6">
                        <h5 v-if="rol==1">Preguntas sobre el proyecto:</h5>
                        <h5 v-else>
                            ¿Tienes alguna pregunta sobre el proyecto?
                             <button v-if="rol == 0"
                                    class="btn btn-sm btn-secondary"
                                    :class="{'btn-warning' : this.flagSuscripcion == true}"
                                    @click="notificar()"
                                    data-toggle="tooltip" data-placement="top" title="Recibir Notificaciones sobre este blog">
                                <font-icon icon="bell"/>
                            </button>
                        </h5>
                    </div>
                    <div class="col-sm-6"></div>
                </div>

              </div>
              <div class="card-body">
                <div class="row pr-3 pl-3" v-if="estado == 2">
                    <div class="input-group">
                        <input type="text"
                               class="form-control"
                               v-model="pregunta"
                               placeholder="Escribe una pregunta..."
                               aria-label="Escribe una pregunta..."
                               aria-describedby="button-addon2">

                        <button class="btn orange" type="button" :disabled="!pregunta" @click="altaComentario(null)">Enviar</button>
                    </div>
                </div>

                <h6 class="mt-4 mb-2" v-if="estado == 2">Comentarios</h6>
                <h6 class="mb-2" v-else>Comentarios</h6>

                <div class="row mt-1 pt-2 pb-2 pregunta" v-for="f in comments" :key="f.id_comentario" :class="f.id_usuario_resp > 0 ? 'respuesta' : ''">
                    <div class="col-sm-1">
                        <small class="float-right">{{f.fecha}}</small>
                    </div>
                    <div class="col-sm-11">
                        <router-link :to="{ name: 'calificacion', params: { id: f.id_usuario}}">
                            {{f.usuario}}
                        </router-link> <span class="text-muted" v-if="f.id_usuario_resp > 0"> @ {{f.usuario_resp}}</span>

                        <p class="p-respuestas">{{f.pregunta}}</p>

                        <div class="input-group input-group-sm mt-1" v-if="true">
                            <input  type="text" class="form-control txt-respuesta"
                                    v-model="f.respuesta"
                                    v-if="estado == 2"
                                    placeholder="Responder..." aria-label="Responder..."
                                    aria-describedby="button-addon2">
                            <button class="btn btn-sm btn-light" type="button" v-if="estado == 2" :disabled="!f.respuesta" @click="altaComentario(f)">Enviar</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'

export default {
mixins: [ globalFunctions ],
name: 'Blog',
props:['id','status'],
data () {
     return {
         pregunta: '',
         comments: '',
         rol: localStorage.rol,
         estado: '',
         flagSuscripcion: false
     }
},
methods:{
    altaComentario(sel){

        let data = {
            pregunta: this.pregunta,
            idEmp: this.id,
            idPropuesta: localStorage.userID,
            idRaiz: 0,
            idUsuarioResp: 0,
            idComentarioResp: 0
        }

        if (sel) {
            data = {
                pregunta: sel.respuesta,
                idEmp: sel.id_proyecto,
                idPropuesta: localStorage.userID,
                idRaiz: sel.id_raiz,
                idUsuarioResp: sel.id_usuario,
                idComentarioResp: sel.id_comentario
            }
        }

        this.axios.post(this.url + 'altaComentario.php', data).then((responce) =>{
            if(responce.data == '200')
            {
                this.pregunta = "";
                this.getComments();
                this.enviarCorreo(11, 'Entrada en el blog', data.idEmp);
            }
            else{
                alert("Error");
            }
        })
    },
    getComments(){
        let data = {
            flag: 7,
            id: this.id
        }

        this.axios.post(this.url + 'getProyectos.php', data).then((responce) =>{ //Get status Proyecto
            this.estado = responce.data[0].estatus_proyecto;
        })

        data = {
            id:this.id
        }

        this.axios.post(this.url + 'getComments.php', data).then((responce) =>{
            this.comments = responce.data;
        })

        this.resetComments();
        this.getSuscripcion();
    },
    getSuscripcion(){
        let data = {
            flag: 0,
            id: this.id,
            user: localStorage.userID
        }

        this.axios.post(this.url + 'getNotificaciones.php', data).then((responce) =>{ //Get status Proyecto
            if(responce.data){
                this.flagSuscripcion = true;
            }else{
                this.flagSuscripcion = false;
            }
        })
    },
    resetComments(){
        if(this.rol == 1){

            let data = {
                id:this.id,
                flag: 0
            }

            this.resetBlog(data);
        } else {

            let data = {
                id:this.id,
                flag: 1,
                user: localStorage.userID,
            }

            this.resetBlog(data);
        }
    },
    resetBlog(data){

        this.axios.post(this.url + 'reset_comments.php', data).then((responce) =>{
            if(responce.data == 200){
                //console.log(responce.data);
            }
        })
    },
    notificar(){
        let data = {};

        if (this.flagSuscripcion == false){
            this.msjOk2("Recibiras un correo cada que haya una nueva entrada en el blog.");

            data = {
                flag: 0,
                user: localStorage.userID,
                id: this.id
            }
        }else{
            this.msjOk2("Ya no recibiras correos para este blog.");

            data = {
                flag: 1,
                user: localStorage.userID,
                id: this.id
            }
        }

        this.axios.post(this.url + 'notificar.php', data).then((responce) =>{ //Get status Proyecto
            if (responce.data == 200){
                this.getSuscripcion();
            }else{
                alert("error");
            }
        });

    }
},
computed:{
    ...mapState(['url'])
},
mounted(){
    this.getComments();
}
}
</script>


<style scoped>
.card-header, .card-footer{
    background-color: white;
}
.pregunta {
    border-left:solid 2px orangered;
    border-top: solid 1px whitesmoke;
    border-bottom: solid 1px whitesmoke;
    padding: 3px;
}
.respuesta {
    margin-left: 20px;
}
.p-respuestas {
    margin-bottom: 3px;
}
.txt-respuesta {
    border-top: 0px;
    border-left: 0px;
    border-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Blog.vue